import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import AuthentificationReducer from "reducers/AuthentificationReducer";
import WebsocketReducer from 'reducers/WebsocketReducer';
import FilterReducer from "reducers/FilterReducer";
import UserPositionReducer from "reducers/UserPositionReducer";
import thunk from "redux-thunk";

export default function configureStore(initialState = {}) {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  return createStore(combineReducers({
    authentification: AuthentificationReducer,
    filter: FilterReducer,
    websocket: WebsocketReducer,
    userPosition : UserPositionReducer
  }), composeEnhancers(applyMiddleware(thunk))
  );
}
